import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { BiBanIcon, CallIcon, PersonIcon } from "../../../images/icons/icons";
import { formatDateTime } from "../../common-data/Converts";

const CallLogsTable = ({ isPage, setIsPage, pageLimit, setPageLimit }) => {
  const { callLogsLoading, callLogsError, callLogsData } = useSelector(
    (state) => state.prospects
  );

  const iniTbDatas = {
    pagination: [],
    allData: [],
  };
  const [allTbDatas, setAllTbDatas] = useState(iniTbDatas);

  useEffect(() => {
    if (
      !callLogsLoading &&
      !callLogsError &&
      callLogsData?.status &&
      callLogsData?.data?.length > 0
    ) {
      setAllTbDatas((prevs) => ({
        ...prevs,
        allData: callLogsData.data,
        pagination:
          callLogsData?.pagination?.length > 0 ? callLogsData.pagination : [],
      }));
    } else {
      setAllTbDatas(iniTbDatas);
    }
  }, [callLogsLoading, callLogsError, callLogsData]);

  const tbColumns = [
    {
      dataField: "agent_name",
      text: "agent info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.agent_name || "NA"}</span>
            </div>

            {row?.agent_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.agent_mobile || ""}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "_cl",
      text: "lead mobile",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <CallIcon />
            </span>
            <span className="tb-data">{row._cl || "NA"}</span>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "call status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.status ? "tb-badge" : ""}  ${
              row?.status === "connected"
                ? "tb-badge-success"
                : row?.status === "connected_user_missed"
                ? "tb-badge-success-2"
                : row?.status
                ? "not-assigned"
                : ""
            }`}
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "_fn",
      text: "Recording Link",
      formatter: (_, row) => {
        return (
          <span className={`tb-data ${row?._fn ? "tb-audio" : ""}`}>
            {row?._fn ? (
              <audio controls>
                <source src={row._fn} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            ) : (
              <BiBanIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "_drm",
      text: "Call Duration (Minutes)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?._drm || "-"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Call Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="common-table-container tb-bordered mt15">
      <CommonTable
        tableData={allTbDatas.allData}
        tablePagination={allTbDatas.pagination}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={callLogsLoading}
      />
    </div>
  );
};

export default CallLogsTable;
